"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CameraPreview = require("./CameraPreview");
Object.keys(_CameraPreview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CameraPreview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CameraPreview[key];
    }
  });
});